import template from './route_stats.html';
import controller from './route_stats.controller';
import './route_stats.scss'

let routeStatsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default routeStatsComponent;


// WEBPACK FOOTER //
// ./client/app/components/route_stats/route_stats.component.js